import { useCallback, useState } from 'react';
import { fetchMsLoginUrl } from '@/hooks/apiHooks/msAzure';
import { SESSION_KEY_LOGIN_REDIRECT_PATH } from '@/constant/keys';

/**
 * MS 재인증 트리거. 웹 전용이다.
 *
 * 앱(웹뷰)은 대상이 아니다. msAzure/instance.ts 의 RN 분기가 인증 실패를
 * MsAuthExpired 로 넘기지 않고 기존대로 FORCE_LOGOUT 을 태우므로,
 * 앱에서는 이 훅을 쓰는 MsAuthRequired 자체가 렌더되지 않는다.
 *
 * /login 으로 보내지 않는 이유: 지금 상황은 포탈 JWT 는 살아있고 MS 토큰만 죽은 것이다.
 * 전면 로그인 화면은 "세션이 끊겼다"는 잘못된 신호를 준다.
 *
 * /redirect 도 진입점이 아니다. code 없이 들어가면 useMsLoginToken 의 SWR key 가 null 이라
 * 요청이 나가지 않고 로딩 스피너에 갇힌다. Azure 로 보내면 복귀 시 자동으로 거치게 된다.
 */
const useMsReauth = () => {
  const [isPending, setIsPending] = useState(false);

  const reauth = useCallback(async () => {
    if (isPending) return;
    setIsPending(true);

    try {
      const { msAzureLoginUrl } = await fetchMsLoginUrl();

      // /redirect 는 이 값이 없으면 홈으로 폴백한다. 회의록처럼 홈이 아닌 화면에서 필수.
      sessionStorage.setItem(
        SESSION_KEY_LOGIN_REDIRECT_PATH,
        encodeURIComponent(window.location.pathname + window.location.search),
      );

      window.location.href = msAzureLoginUrl;
      // 페이지가 떠날 때까지 isPending 을 유지해 버튼 중복 클릭을 막는다.
    } catch {
      setIsPending(false);
    }
  }, [isPending]);

  return { reauth, isPending };
};

export default useMsReauth;
